import { render, staticRenderFns } from "./GhostwritingThread.vue?vue&type=template&id=020987ba&"
import script from "./GhostwritingThread.vue?vue&type=script&lang=js&"
export * from "./GhostwritingThread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports